var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',[_c('div',{staticClass:"pb90",attrs:{"slot":"pageRight"},slot:"pageRight"},[_c('div',{staticClass:"mt20"},[_c('div',{staticClass:"empty-box bg-white border-radius-4 flex flex-acenter flex-jcenter",staticStyle:{"height":"200px"}},[_c('a-empty')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }